import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

const { EVENT_CONTACT_1STDIBS } = eventNameConstants;
const { INTERACTION_TYPE_CONTACT_SUBMITTED } = interactionTypeConstants;
const { STEP_INTERACTION_CHAT_INITIATED, STEP_INTERACTION_CHAT_BUTTON_DISPLAYED } =
    stepInteractionConstants;

function trackChatInitiated({ placement, label }: { placement: string; label?: string }): void {
    trackEvent({
        eventName: EVENT_CONTACT_1STDIBS,
        interaction_type: INTERACTION_TYPE_CONTACT_SUBMITTED,
        step_interaction_name: STEP_INTERACTION_CHAT_INITIATED,
        trigger: `${placement}${label ? ` - ${label}` : ''}`,
    });
}

function trackChatButtonDisplayed({ placement }: { placement: string }): void {
    trackEvent({
        eventName: EVENT_CONTACT_1STDIBS,
        interaction_type: INTERACTION_TYPE_CONTACT_SUBMITTED,
        step_interaction_name: STEP_INTERACTION_CHAT_BUTTON_DISPLAYED,
        trigger: `${placement} chat button`,
    });
}

export { trackChatInitiated, trackChatButtonDisplayed };
